// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const INWARD_MODE_FOUNDARY = 1; // Inward Foundary
export const INWARD_MODE_CHEMICAL = 2; // Inward Chemical
export const INDIAN_CURRENCY = 1; // Currency 1 for India
//const BASE_URL = 'http://192.168.1.70:8082/';
const BASE_URL = 'https://erpv5.neofruition.co.in/';
// const BASE_URL = 'http://demoao.neofruition.co.in:84/';
// const BASE_URL = 'http://demoao.neofruition.co.in:84/';
// const BASE_URL = 'http://erpv5.neofruition.co.in/';
//const BASE_URL = 'http://localhost:8080/';
// const BASE_URL = 'http://192.168.0.41:8080/';
// const BASE_URL = 'http://dppl.neofruition.co.in/';
// const BASE_URL = 'http://localhost:8080/';
export const environment = {
  production: false,
  SERVER_URL: BASE_URL + 'api/v1/',
  AUTH_URL: BASE_URL + 'login',
  ACL_URL: BASE_URL + 'api/v1/acl',
  LOGGED_IN_USER_URL: 'staff/getloggedinuser',
  ACL_LOCAL_KEY: 'aclData',
  LOGGED_IN_USER_KEY: 'loggedInUser',
  PRINT_HEADER_IMG_URL: BASE_URL + 'images/header.jpg',
  PRINT_FOOTER_IMG_URL: '',
  DATE_FORMAT: 'dd-MM-yyyy',
  NUMBER_FORMAT: '1.0-4',
  DOWNLOAD_GET_FILE: BASE_URL + 'file/get/',
  // LAB_REPORT_DOWNLOAD: 'bpdao.neofruition.co.in/report/',
  LAB_REPORT_DOWNLOAD: BASE_URL + 'report/',
  INWARD_MODE: INWARD_MODE_CHEMICAL,
  DISPTACH_FINISH_PRODUCT_SUPPORT: false,
  FOOTER_TITLE: 'Neofrutiion',
  FOOTER_URL: 'https://www.neofruition.com/',
  CURRENCY: INDIAN_CURRENCY,
  QR_DOC_URL: BASE_URL,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
